var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { assert } from "@ember/debug";
import { action } from "@ember/object";
import Service, { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { getItemFromLocalStorage, setItemInLocalStorage } from "core/utils/use-local-storage";
const NAVIGATION_STORAGE_EMBEDDED_KEY = "service:navigation:embedded";
let NavigationService = (_class = class NavigationService extends Service {
  constructor(owner) {
    super(owner);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    /**
     * How deep we are in the history
     *
     * This counter is incremented everytime the router transitions without the intent to go back in the history.
     * On the other hand, if the transition was initiated with the back action, this counter is decremented
     *
     * When depth === 1, there is no history to go back to
     *
     * @property depth
     * @type {Number}
     */
    _initializerDefineProperty(this, "depth", _descriptor3, this);
    // Private properties
    _initializerDefineProperty(this, "_shouldGoBack", _descriptor4, this);
    this.router.on("routeDidChange", this._updateDepth.bind(this));
  }

  /** Inverse of embedded */
  get standalone() {
    return !this.embedded;
  }

  /**
   * Is the application is inside an iframe
   */
  get embedded() {
    const value = getItemFromLocalStorage(NAVIGATION_STORAGE_EMBEDDED_KEY);
    return value ? Boolean(JSON.parse(value)) : false;
  }
  set embedded(val) {
    setItemInLocalStorage(NAVIGATION_STORAGE_EMBEDDED_KEY, val);
    console.debug(`${val ? "Activate" : "Deactivate"} embedded navigation`);
  }
  get canGoBack() {
    return !this.cannotGoBack;
  }
  get cannotGoBack() {
    if (this.depth === 0) return true;
    return this.depth === 1;
  }
  get currentRouteName() {
    return this.router.currentRouteName;
  }
  get currentPatientRouteName() {
    return this.session.patient ? "patient-web.protected" : "medics-web.protected.patients.patient";
  }
  getAbsoluteRouteFromContextual(contextualRoute) {
    return contextualRoute ? `${this.currentPatientRouteName}.${contextualRoute}` : undefined;
  }
  back() {
    assert(`You are trying to use ${this.constructor.name}.back(), but the current location implementation '${this.router.location.implementation}' does not support the browser's history API`, !!this.router.location.history);
    this._shouldGoBack = true;
    this.router.location.history.back();
  }
  _updateDepth({
    from,
    to
  }) {
    // If there is no from, we are landing on the app, so depth should not be touched
    if (!from) return;

    // If we are transitioning to the same route, do nothing
    if (from.name === to.name) return;

    // increment depth and early return if we do not want to go back
    if (!this._shouldGoBack) return this.depth = this.depth + 1;

    // We want to go back, let's decrement depth and reset shouldGoBack
    this.depth = this.depth - 1;
    this._shouldGoBack = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "depth", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_shouldGoBack", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "back", [action], Object.getOwnPropertyDescriptor(_class.prototype, "back"), _class.prototype), _class);
export { NavigationService as default };